import { callAPi } from "./api";

const create = (data) => callAPi.post("/create", data);
const edit = (data, id) => callAPi.patch(`/edit/${id}`, data);
const get = () => callAPi.get("/gallery/slider");
const getByID = (id) => callAPi.get(`/get/{id}`);

const deleteBoardMember = (data) => callAPi.delete("/delete", data);

const sliderServices = {
  create,
  edit,
  get,
  deleteBoardMember,
};

export default sliderServices;
